export default __webpack_public_path__ + "static/media/ic_fastpay.3bac4734.png";